var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "man_1_",
    "data-name": "man (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    d: "M16.134,81.224H85.858a39.355,39.355,0,0,0,5.136-19.486,40,40,0,0,0-79.994,0,39.351,39.351,0,0,0,5.135,19.488Z",
    transform: "translate(-10.997 -22)",
    fill: "#ffc839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M184.3,279.425a9.1,9.1,0,0,1,3.293,2.463,9.1,9.1,0,0,1,3.293-2.463l9.284-4.722q-1.168-.363-2.381-.642c-1.576-1.576-1.976-4.565-2.048-6.656a17.4,17.4,0,0,1-2.511,2.4,9.2,9.2,0,0,1-11.268,0,17.424,17.424,0,0,1-2.511-2.4c-.072,2.091-.472,5.078-2.048,6.656q-1.217.281-2.384.644Z",
    transform: "translate(-148.754 -226.493)",
    fill: "#ffaa7b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M203.22,271.725a9.183,9.183,0,0,1-5.248-1.917,17.406,17.406,0,0,1-2.511-2.4,12.09,12.09,0,0,1-1.491,5.973c1.589,3.207,3.648,5.891,5.73,4.487A8.2,8.2,0,0,0,203.22,271.725Z",
    transform: "translate(-164.66 -226.444)",
    fill: "#fc9460"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M153.716,330.4l-4.414-2.246a5.976,5.976,0,0,0-4.534,5.956c-1.269.22-7.655,1.625-7.655,7.592v11.928a40.571,40.571,0,0,0,19.782,5.116c.142,0,.284,0,.426-.005V334.006C157.321,331.981,153.716,330.4,153.716,330.4Z",
    transform: "translate(-116.653 -278.747)",
    fill: "#7e6dd1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M74.809,341.008V328.943c0-6.447,7.652-7.378,7.652-7.378a5.789,5.789,0,0,1,4.6-6.011l-5.32-2.706c-11.391,3.715-16.832,5.2-19.668,7.225,2.954,2.015,7.6,6.2,7.6,12.608v4.992a40.822,40.822,0,0,0,5.139,3.334Z",
    transform: "translate(-53.572 -265.988)",
    fill: "#7255ce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M266.468,312.851l-9.42,4.793s-3.605,1.581-3.605,3.605v24.735c.142,0,.283.005.426.005a41.1,41.1,0,0,0,5.631-.388h0l11.612-3.431h0a40.751,40.751,0,0,0,7.425-4.492v-4.992c0-6.406,4.645-10.592,7.6-12.608C283.3,318.051,277.859,316.566,266.468,312.851Z",
    transform: "translate(-214.639 -265.99)",
    fill: "#9589e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4871",
    "data-name": "Path 4871",
    d: "M279.151,286.923a.323.323,0,0,0-.473.219,12.738,12.738,0,0,1-6.107,8.4.819.819,0,0,0-.218,1.251l4.635,5.309a2.1,2.1,0,0,0,3.429-.384,61.76,61.76,0,0,0,4.021-9.092,1.856,1.856,0,0,0-.394-1.847A19.273,19.273,0,0,0,279.151,286.923Z",
    transform: "translate(-229.663 -243.839)",
    fill: "#b5b0f7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M192.21,328.242a12.406,12.406,0,0,1-2.761-2.125c-1.116.095-5.971.811-6.249,6.038.415.842.809,1.606,1.163,2.264a2.1,2.1,0,0,0,3.429.384l4.635-5.309a.819.819,0,0,0-.218-1.251Z",
    transform: "translate(-155.157 -276.59)",
    fill: "#9589e8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M171.3,287.142a.323.323,0,0,0-.473-.219,19.275,19.275,0,0,0-4.893,3.849,1.857,1.857,0,0,0-.394,1.847,58.7,58.7,0,0,0,3.092,7.3c0-6.17,6.249-6.274,6.249-6.274h0A12.936,12.936,0,0,1,171.3,287.142Z",
    transform: "translate(-140.291 -243.795)",
    fill: "#7e6dd1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M402.263,373.547a40.967,40.967,0,0,0,11.193-12.715,21.1,21.1,0,0,0-1.022-2.542,6.781,6.781,0,0,0-2.407-2.711c-2.941,1.969-7.766,6.195-7.766,12.723Z",
    transform: "translate(-338.697 -301.609)",
    fill: "#b5b0f7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M45.88,355.58a6.78,6.78,0,0,0-2.407,2.711,21.129,21.129,0,0,0-1.022,2.542,40.965,40.965,0,0,0,11.193,12.715V368.3c0-6.529-4.825-10.753-7.766-12.723Z",
    transform: "translate(-37.215 -301.609)",
    fill: "#7e6dd1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M298.879,420.625h-7.735a2,2,0,0,0-2,2v12.147a1.968,1.968,0,0,0,.12.674,40.47,40.47,0,0,0,11.612-3.431v-9.39a2,2,0,0,0-2-2Z",
    transform: "translate(-243.882 -355.831)",
    fill: "#b5b0f7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M375.738,88.206c-3.871,2.861-8.686,7.684-6.645,13.727,3.161,9.359-11.148,15.26,4.826,22.044,6.387,2.712,10.1,5.542,12.254,7.962a40.806,40.806,0,0,0-10.435-43.733Z",
    transform: "translate(-308.638 -77.191)",
    fill: "#ffdd40"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M23.894,88.206c3.871,2.861,8.686,7.684,6.645,13.727-3.161,9.359,11.148,15.26-4.826,22.044-6.387,2.712-10.1,5.542-12.254,7.963A40.806,40.806,0,0,1,23.894,88.206Z",
    transform: "translate(-10.994 -77.191)",
    fill: "#ffdd40"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M151.427,24.453h28.458c.052-2.051.392-7.478,2.536-11.344a2.134,2.134,0,0,0,.144-1.755c-.777-2.168-3.1-7.236-8.166-8.588a.338.338,0,0,1-.122-.594l.759-.6a.51.51,0,0,0-.218-.9c-3.737-.721-16.15-2.445-20,5.482a1.8,1.8,0,0,1-1.173.946,6.928,6.928,0,0,0-4.457,3.788,2.146,2.146,0,0,0-.117,1.651A44.774,44.774,0,0,1,151.427,24.453Z",
    transform: "translate(-126.738 0.348)",
    fill: "#56415e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M164.162,11.936C159.617,5.009,167.568.017,167.568.017c-4.819.062-10.392,1.3-12.753,6.152a1.8,1.8,0,0,1-1.173.946,6.927,6.927,0,0,0-4.457,3.788,2.146,2.146,0,0,0-.117,1.651,44.8,44.8,0,0,1,2.359,11.913h6.624c4.192-3.4,8.81-8.415,6.109-12.531Z",
    transform: "translate(-126.56 0.333)",
    fill: "#45304c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M337.475,150.335c-.637-.584-2.061-.288-2.61.069a7.71,7.71,0,0,1,.023,2.271l-.648,4.716q0,.57-.034,1.119a2.135,2.135,0,0,0,2.651-1.914,7.226,7.226,0,0,1,.279-1.234C337.556,154.051,339.072,151.8,337.475,150.335Z",
    transform: "translate(-283.511 -126.861)",
    fill: "#ffaa7b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M152.854,150.335c.637-.584,2.061-.288,2.61.069a7.711,7.711,0,0,0-.023,2.271l.647,4.716q0,.57.034,1.119a2.135,2.135,0,0,1-2.651-1.914,7.23,7.23,0,0,0-.279-1.234C152.774,154.051,151.258,151.8,152.854,150.335Z",
    transform: "translate(-129.154 -126.861)",
    fill: "#fc9460"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    d: "M242.772,82.454a6,6,0,0,0-.649-1.129,3.038,3.038,0,0,1-.592-2.068c.175-2.087.081-6.167-3.088-7.4-2.692-1.047-5.994-.441-8.1.164a7.687,7.687,0,0,1-4.065.041c-2.4,1.592-2.455,5.176-2.294,7.085a3.051,3.051,0,0,1-.6,2.078,6.051,6.051,0,0,0-.641,1.107,6.685,6.685,0,0,0-.5,3.812l.759,4.78c0,6.872,4.243,11.542,7.851,13.965a11.034,11.034,0,0,0,1.7.928,11.025,11.025,0,0,0,2.2-1.136A16.7,16.7,0,0,0,242.5,90.9l.749-4.716A6.6,6.6,0,0,0,242.772,82.454Z",
    transform: "translate(-192.514 -59.871)",
    fill: "#ffc7ab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(25.89 11.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M187.27,104.679a17.33,17.33,0,0,1-6.7-13.785l-.648-4.716a7.541,7.541,0,0,1,.427-3.762,6.251,6.251,0,0,1,.547-1.093,3.357,3.357,0,0,0,.514-2.051c-.143-1.943-.087-5.649,2.157-7.136-.136-.035-.272-.073-.406-.118-1.82-.605-4.675-1.212-7-.164-2.747,1.236-2.821,5.338-2.668,7.418a3.356,3.356,0,0,1-.514,2.051,6.259,6.259,0,0,0-.547,1.093A7.541,7.541,0,0,0,172,86.179l.648,4.716a17.331,17.331,0,0,0,6.7,13.785,9.2,9.2,0,0,0,9.593,1.031,9.139,9.139,0,0,1-1.674-1.031Z",
    transform: "translate(-171.929 -71.286)",
    fill: "#ffaa7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.e4db689bce6b71f33f75a8df0ccc5fad.svg";
export { ForwardRef as ReactComponent };